import classNames from 'classnames';
import './BillingPeriodTitle.scss';

const BillingPeriodTitle = ( { text }: { text: string } ) => (
	<div className={classNames( 'BillingPeriodTitle' )}>
		<div className={classNames( 'billingPeriodContainer' )}>
			<p>{text}</p>
		</div>
	</div>
);

export default BillingPeriodTitle;
